// Les dates de l'API (« 2026-11-20 12:00 » ou ISO) dites comme on les dit : « il y a 5 min », « 20 nov. ».

export function lireDate(texte: string | null | undefined): Date | null {
  if (!texte) return null;
  const d = new Date(texte.includes("T") ? texte : texte.replace(" ", "T"));
  return Number.isNaN(d.getTime()) ? null : d;
}

const JOUR = 86_400_000;
const jourMois = new Intl.DateTimeFormat("fr-FR", {
  day: "numeric",
  month: "short",
});
const jourMoisHeure = new Intl.DateTimeFormat("fr-FR", {
  weekday: "short",
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
});

// « à l'instant », « il y a 12 min », « il y a 3 h », « hier », puis la date.
export function ilYa(
  texte: string | null | undefined,
  maintenant = Date.now(),
): string {
  const d = lireDate(texte);
  if (!d) return "";
  const ecart = maintenant - d.getTime();
  if (ecart < 60_000) return "à l'instant";
  if (ecart < 3_600_000) return `il y a ${Math.floor(ecart / 60_000)} min`;
  if (ecart < 12 * 3_600_000)
    return `il y a ${Math.floor(ecart / 3_600_000)} h`;
  if (ecart < 2 * JOUR) return "hier";
  return jourMois.format(d);
}

// Les jours qui restent avant une échéance, comptés en jours du calendrier (négatif : passée).
export function joursAvant(
  texte: string,
  maintenant = new Date(),
): number | null {
  const d = lireDate(texte);
  if (!d) return null;
  const minuit = (x: Date) =>
    new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  return Math.round((minuit(d) - minuit(maintenant)) / JOUR);
}

// « 24 oct. »
export const dateCourte = (texte: string) => {
  const d = lireDate(texte);
  return d ? jourMois.format(d) : texte;
};

// « ven. 20 nov., 12:00 »
export const dateLongue = (texte: string) => {
  const d = lireDate(texte);
  return d ? jourMoisHeure.format(d) : texte;
};

// « dans 27 jours », « demain », « aujourd'hui », « passée depuis 3 jours »
export function echeance(jours: number): string {
  if (jours === 0) return "aujourd'hui";
  if (jours === 1) return "demain";
  if (jours > 1) return `dans ${jours} jours`;
  return jours === -1 ? "passée d'un jour" : `passée de ${-jours} jours`;
}
